import { render, staticRenderFns } from "./SelectAvaliationItemStrategy.vue?vue&type=template&id=56a5e8c1"
import script from "./SelectAvaliationItemStrategy.vue?vue&type=script&lang=js"
export * from "./SelectAvaliationItemStrategy.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports